<template>
  <div class="comp-con flex flex-row align-center justify-between">
    <div class="info-con flex flex-row align-center">
      <img class="profile" src="@/assets/list/profile.png" alt="profile">
      <div class="info flex flex-col align-start">
        <span class="name">
          {{ name }}
        </span>
        <span class="description text-ellipsis">
          {{ description }}
        </span>
      </div>
    </div>
    <el-button type="primary" size="small" @click="enroll">挂号</el-button>
  </div>
</template>
<script>
export default {
  name: "DoctorItem",
  props: {
    code: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "张大夫"
    },
    description: {
      type: String,
      default: "这是一个专业的医生"
    }
  },
  inject: ["pageData"],
  methods: {
    /**
     * 挂号
     */
    enroll() {
      this.pageData.enrollForm.storeUserCode = this.code
      this.pageData.enrollVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.comp-con {
  padding: 21px 16px;
  border: 1px solid #E5E9EF;
  border-radius: 4px 4px 4px 4px;
  width: 324px;

  .info-con {
    .profile {
      width: 50px;
      height: 50px;
      margin-right: 12px;
    }

    .info {
      .name {
        font-family: PingFang SC, PingFang SC, serif;
        font-weight: bolder;
        font-size: 14px;
        color: #111111;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 3px;
      }

      .description {
        font-family: PingFang SC, PingFang SC, serif;
        font-weight: bold;
        font-size: 12px;
        color: #999999;
        text-align: left;
        font-style: normal;
        text-transform: none;
        width: 108px;
      }
    }
  }
}
</style>
